import { render, staticRenderFns } from "./PartnerItemComponent.vue?vue&type=template&id=24aa8271&"
import script from "./PartnerItemComponent.vue?vue&type=script&lang=js&"
export * from "./PartnerItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports